import platform from 'platform';
import * as crypto from 'crypto-js';
import Cookies from 'js-cookie';
import { countryMappingCode } from '../Utils/helper';
import { states } from '../components/AddressPage/constant';
import { createRestApiClient } from '../datafetchers';
import axios from 'axios';
import { fireEvent } from '../Utils/fireEvent';

export const pageview = () => {
  window.fbq('track', 'PageView');
};

export const event = (name, options = {}, EventId) => {
  window.fbq('track', name, options, { eventID: EventId });
};

const getUserData = (mobile) => {
  const user = Cookies.get('is_default')
    ? JSON.parse(Cookies.get('is_default'))
    : null;
  const leadMobile = mobile ? mobile : user?.mobile;
  const phoneNo = '91' + leadMobile;
  let state = null;
  if (user?.state) {
    state = states.find(
      (element) => element?.name.toLowerCase() === user?.state?.toLowerCase(),
    );
  }
  const countryCode = getCountryCode(user?.country);
  const firstName = user?.name.split(' ')[0];
  const lastName = user?.name.split(' ')[1];
  const userData = {
    ph: phoneNo ? [getHashedValue(phoneNo)] : '',
    ct: user?.city ? [getHashedValue(user?.city?.toLowerCase())] : '',
    zp: user?.zipcode ? [getHashedValue(user?.zipcode?.toString())] : '',
    country: user?.country ? getHashedValue(countryCode) : '',
    fn: firstName ? getHashedValue(firstName) : '',
    ln: lastName ? getHashedValue(lastName) : '',
    st: state ? getHashedValue(state?.key?.toLowerCase()) : '',
    em: user?.email ? [getHashedValue(user?.email?.toLowerCase())] : '',
  };
  return userData;
};

const getClientData = () => {
  const fbp = Cookies.get('_fbp') ? Cookies.get('_fbp') : null;
  const fbc = Cookies.get('_fbc') ? Cookies.get('_fbc') : null;
  const clientData = {
    client_user_agent: platform.name + '/' + platform.version,
    fbp: fbp,
    fbc: fbc,
  };
  return clientData;
};

const getClientIPAddress = async () => {
  const restApiClient = axios.create({
    baseURL: 'https://api64.ipify.org?format=json',
  });
  const data = await restApiClient
    .request({
      method: 'GET',
      url: ``,
    })
    .then((res) => res.data);

  return data.ip;
};

export const fireFbConversionApiEvent = async (
  eventName,
  data,
  EventId,
  mobile,
) => {
  if (fireFbEventProdCheck()) {
    const userData = getUserData(mobile);
    const clientData = getClientData();
    const clientIp = await getClientIPAddress();
    if (!clientIp) {
      fireEvent({
        category: 'conversion_api_ip_missing',
      });
    }
    const finalData = {
      ...clientData,
      ...userData,
      client_ip_address: clientIp,
    };
    const user_data = finalData;
    const eventsData = {
      data: [
        {
          event_name: eventName,
          event_time: getSeconds(),
          event_source_url: window.location.origin + window.location.pathname,
          user_data: user_data,
          custom_data: data,
          event_id: EventId,
          action_source: 'website',
        },
      ],
    };

    const pixelId = 1560174350951119;
    const accessToken =
      'EAAJh4zXCjn8BAIkyT7HNkon7apbWiXR5v9lGzpUxjrrNHqdkdeCq0ShkC8UDQL0ZB6vvmcyAQmFtRSj7oPjbeonMK3IUUW30xZAnsmTD3ENm1t2X8na3z4HMUUFwHcli3QxfAiWVG3b3nYO0NeFEZABIeM0NUCB46Eq9TJ4IOEbv1UTLt3h';
    const url = `https://graph.facebook.com/v13.0/${pixelId}/events?access_token=${accessToken}`;
    await axios.request({
      method: 'POST',
      url: url,
      data: eventsData,
      headers: { 'Content-Type': 'application/json' },
    });
  }
};

const getCountryCode = (countryName) => {
  for (let i = 0; i < countryMappingCode.length; i++) {
    const currObj = countryMappingCode[i];
    if (currObj.name === countryName) return currObj.code.toLowerCase();
  }
};

export const getSeconds = () => {
  let currentDateTime = new Date();
  let resultInSeconds = Math.round(currentDateTime.getTime() / 1000, 0);
  return resultInSeconds;
};

export const fireFbEventProdCheck = () => {
  const fbp = Cookies.get('_fbp');
  const fireEvent = process.env.NEXT_PUBLIC_APP_TYPE === 'production' && fbp;
  return fireEvent;
};
const getHashedValue = (value) => {
  const newValue = value?.replace(/"/gi, '');
  return crypto.SHA256(newValue).toString(crypto.enc.Hex);
};
